<template>
    <div style="width: 100%; background:#e7e7e7">
        <v-parallax class="hidden-sm-and-down" height="600" style="background: #000" src="https://pipemein.com/files/pipemein/image/3.JPEG">
            <v-layout row justify-center class="margins">
                <v-flex xs12 md3 v-for="item in procutsExternal" :key="item.name">
                    <v-card v-if="item.iscoming === false" width="300" height="400" flat class="cards" color="#F2F2F2">
                        <div class="text-center mt-5 blue--text">
                            <h3>Order Now!</h3> 
                        </div>
                        <v-card-text> 
                            <img :src="item.image" 
                            style="
                            border: solid #ccc 1px;
                            border-radius:50%;width:150px;height:150px;margin:0 auto;display:block;" width="150" height="150">
                            
                        </v-card-text>   
                        <v-card-text class="text-center"> 
                            <p class="black--text" style="font-size:18px;font-weight:600">
                                {{item.name}}
                            </p>
                            <label style="color: green;">Save time, Save money & Resources</label>
                            <div class="mt-2">
                                
                                <v-btn :to="{name: 'details', params: {id: item.id}}" class="my-3 btns" small text>
                                    <strong>
                                        Order Now!
                                    </strong>
                                </v-btn>
                                <!--<v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="bnshh mt-2" outlined small :to="{name: 'details', params:{id: item.id}} ">
                                    <strong>
                                        See more 
                                    </strong>
                                </v-btn>
                                </template>
                                <span>Click for Products specifications</span>
                                </v-tooltip>-->
                            </div>
                            
                        </v-card-text>
                    </v-card>
                    <v-card v-if="item.iscoming === true" disabled width="300" height="400" flat class="cards" color="#F2F2F2">
                        <div class="text-center mt-5 red--text">
                            <h3>COMING SOON</h3> 
                        </div>
                        <v-card-text>
                            <img class="jfhfj" :src="item.image" 
                            style="
                            border: solid #ccc 1px;
                            border-radius:50%;width:150px;height:150px;margin:0 auto;display:block;" width="150" height="150">
                            
                        </v-card-text>   
                        <v-card-text class="text-center"> 
                            <h2 class="black--text">
                                {{item.name}}
                            </h2>
                            <label style="color: green;">Save time, Save money & Resources</label>
                            <div class="mt-2">
                                <h2 class="black--text" style="transform: rotate(-30deg); margin-top: 40px;">
                                    Coming Soon
                                </h2>
                                <!--<v-btn :to="{name: 'details', params: {id: item.id}}" class="my-3 btns" small text>
                                    <strong>
                                        Order Now!
                                    </strong>
                                </v-btn>
                                <h4 class="black--text">
                                    (For every 10 units save $20 <br> on your purchase)
                                </h4>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="bnshh mt-2" outlined small :to="{name: 'details', params:{id: item.id}} ">
                                    <strong>
                                        See more 
                                    </strong>
                                </v-btn>
                                </template>
                                <span>Click for Products specifications</span>
                                </v-tooltip>-->
                            </div>
                            
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-parallax>

        <v-layout justify-center row class="hidden-md-and-up">
            <v-carousel hide-delimiters> 
                <v-flex v-for="item in procutsExternal" :key="item.name">
                <v-carousel-item 
                >
                
                <v-card v-if="item.iscoming === false" height="470" flat class="cards" color="#F2F2F2">
                        <div class="text-center mt-5 blue--text">
                            <h3>Order Now!</h3> 
                        </div>
                        <v-card-text>
                            <img class="jfhfj" :src="item.image" 
                            style="
                            border: solid #ccc 1px;
                            border-radius:50%;width:150px;height:150px;margin:0 auto;display:block;" width="150" height="150">
                            
                        </v-card-text>   
                        <v-card-text class="text-center"> 
                            <h2 class="black--text">
                                {{item.name}}
                            </h2>
                            <label style="color: green;">Save time, Save money & Resources</label>
                            <div class="mt-2">
                               
                                <v-btn :to="{name: 'details', params: {id: item.id}}" class="my-3 btns" small text>
                                    <strong>
                                        Order Now!
                                    </strong>
                                </v-btn>                                
                            </div>
                            
                        </v-card-text>
                    </v-card>
                    <v-card v-if="item.iscoming === true" disabled height="470" flat class="cards" color="#F2F2F2">
                        <div class="text-center mt-5 red--text">
                            <h3>COMING SOON</h3> 
                        </div>
                        <v-card-text>
                            <img class="jfhfj" :src="item.image" 
                            style="
                            border: solid #ccc 1px;
                            border-radius:50%;width:150px;height:150px;margin:0 auto;display:block;" width="150" height="150">
                            
                        </v-card-text>   
                        <v-card-text class="text-center"> 
                            <h2 class="black--text">
                                {{item.name}}
                            </h2>
                            <label style="color: green;">Save time, Save money & Resources</label>
                            <div class="mt-2">
                                <h1 class="black--text" style="transform: rotate(-30deg); margin-top: 60px;">
                                    Coming Soon
                                </h1></div>
                                <!--<v-btn :to="{name: 'details', params: {id: item.id}}" class="my-3 btns" small text>
                                    <strong>
                                        Order Now!
                                    </strong>
                                </v-btn>
                                <h4 class="black--text">
                                    (For every 10 units save $20 <br> on your purchase)
                                </h4>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" class="bnshh mt-2" outlined small :to="{name: 'details', params:{id: item.id}} ">
                                    <strong>
                                        See more 
                                    </strong>
                                </v-btn>
                                </template>
                                <span>Click for Products specifications</span>
                                </v-tooltip>-->
                            
                            <!--<div class="mt-2">
                                <h3>
                                    $75 Each
                                </h3>
                                <v-btn :to="{name: 'details', params: {id: item.id}}" class="my-3 btns" small text>
                                    <strong>
                                        Order Now!
                                    </strong>
                                </v-btn>
                                <h4 class="black--text">
                                    (For every 10 units save $20 on your purchase)
                                </h4> 
                                <v-btn class="bnshh black--text mt-2" outlined small :to="{name: 'details', params:{id: item.id}} ">
                                    <strong>
                                        See more 
                                    </strong>
                                </v-btn>
                            </div>-->
                            
                        </v-card-text>
                    </v-card>
                </v-carousel-item></v-flex>
            </v-carousel>
        </v-layout>
        
    </div>
</template>


<style>
.btns {
    
    background: rgba(255,183,0,1);
    background: -moz-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,183,0,1)), color-stop(100%, rgba(232,139,0,1)));
    background: -webkit-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -o-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: -ms-linear-gradient(top, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    background: linear-gradient(to bottom, rgba(255,183,0,1) 0%, rgba(232,139,0,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffb700', endColorstr='#e88b00', GradientType=0 );
    color: #111;
    padding: 10px 20px 10px 20px;
    text-transform: none;
}
.jfhfj:hover {
    width: 160px;
    transform: scale(1.1);
    height:160px;
}
.bnshh {
    text-transform: none;
    color: #000;
}
.bnshh:hover {
    text-decoration: underline;
    color: orange;
}
    .cards {
        border-radius: 0%;
        background-color: #ececec;
        border: #000 solid 1px;
    }
    .margins {
        margin-top: 100px;
    }
</style>
<script>
import { mapState, mapActions } from "vuex";
export default {
    
data() {
    return {
        
    }
},
created(){
    this.getProductsFirebase();
},
methods:{
    ...mapActions(['getProductsFirebase'])
},
computed: {
    ...mapState(['procutsExternal'])
},

    
}
</script>